import { Button, Modal } from "../ui";

type AddProspectsChooserModalProps = {
  open: boolean;
  onClose: () => void;
  onFindProspects: () => void;
  onImportProspects: () => void;
};

export default function AddProspectsChooserModal({
  open,
  onClose,
  onFindProspects,
  onImportProspects,
}: AddProspectsChooserModalProps) {
  return (
    <Modal isOpen={open} onClose={onClose} title="Add Prospects" size="small">
      <p className="mb-4 text-sm text-dark-grey">
        Choose how you want to add prospects to innLead.
      </p>
      <div className="flex flex-col gap-3">
        <button
          type="button"
          onClick={onFindProspects}
          className="rounded-[10px] border border-mainColor/30 bg-primary/40 p-4 text-left transition hover:border-mainColor hover:bg-primary/60"
        >
          <p className="text-sm font-semibold text-dark-black">Find Prospects</p>
          <p className="mt-1 text-xs text-dark-grey">
            Define your target audience and let innLead find matching prospects for you.
          </p>
        </button>
        <button
          type="button"
          onClick={onImportProspects}
          className="rounded-[10px] border border-light-grey bg-white p-4 text-left transition hover:border-mainColor/40 hover:bg-background-grey"
        >
          <p className="text-sm font-semibold text-dark-black">Import Prospects</p>
          <p className="mt-1 text-xs text-dark-grey">
            Paste a LinkedIn / Sales Navigator URL, group, event, profile, or upload a CSV.
          </p>
        </button>
      </div>
      <div className="mt-5 flex justify-end">
        <Button variant="outline" size="sm" onClick={onClose}>
          Cancel
        </Button>
      </div>
    </Modal>
  );
}
